import { loadCartData, selectedGoods, updateGoodsNumPrice, submitGoodsCart, delGoods, getGoodsTotalNum } from '../../../../fetch/shopping-cart/distributor'
import { ResultCode } from '~const/ResultCode'
const types = {
  LOAD_CART_DATA: 'LOAD_CART_DATA',
  SELECT_CART: 'SELECT_CART',
  UPDATE_GOODS_NUM_PRICE: 'UPDATE_GOODS_NUM_PRICE',
  POST_GOODS_CART: 'POST_GOODS_CART',
  DEL_GOODS: 'DEL_GOODS',
  GOODS_NUM: 'GOODS_NUM'
}
const distributor = {
  state: {
    [types.LOAD_CART_DATA]: null,
    [types.SELECT_CART]: null,
    [types.UPDATE_GOODS_NUM_PRICE]: null,
    [types.POST_GOODS_CART]: null,
    [types.DEL_GOODS]: null,
    [types.GOODS_NUM]: {
      quantity: 0,
      status: 0
    }

  },
  actions: {
    [types.LOAD_CART_DATA]: async ({ commit }, params) => {
      const res = await loadCartData(params)
      return commit(types.LOAD_CART_DATA, res)
    },
    [types.SELECT_CART]: async ({ commit }, params) => {
      const res = await selectedGoods(params)
      return commit(types.SELECT_CART, res)
    },
    [types.UPDATE_GOODS_NUM_PRICE]: async ({ commit }, params) => {
      const res = await updateGoodsNumPrice(params)
      return commit(types.UPDATE_GOODS_NUM_PRICE, res)
    },
    [types.POST_GOODS_CART]: async ({ commit }, params) => {
      const res = await submitGoodsCart(params)
      return commit(types.POST_GOODS_CART, res)
    },
    [types.DEL_GOODS]: async ({ commit }, params) => {
      const res = await delGoods(params)
      return commit(types.DEL_GOODS, res)
    },
    [types.GOODS_NUM]: async ({ commit }, params) => {
      const { status, data } = await getGoodsTotalNum(params)
      if (status === ResultCode.SUCCESS) {
        return commit(types.GOODS_NUM, { ...data, status })
      }
    }

  },
  mutations: {
    [types.LOAD_CART_DATA]: (state, res) => {
      state[types.LOAD_CART_DATA] = res
    },
    [types.SELECT_CART]: (state, res) => {
      state[types.SELECT_CART] = res
    },
    [types.UPDATE_GOODS_NUM_PRICE]: (state, res) => {
      state[types.UPDATE_GOODS_NUM_PRICE] = res
    },
    [types.POST_GOODS_CART]: (state, res) => {
      state[types.POST_GOODS_CART] = res
    },
    [types.DEL_GOODS]: (state, res) => {
      state[types.DEL_GOODS] = res
    },
    [types.GOODS_NUM]: (state, res) => {
      state[types.GOODS_NUM] = res
    }

  },
  getters: {
    getCartData (state) {
      return state[types.LOAD_CART_DATA]
    },
    getSelectedGoods (state) {
      return state[types.SELECT_CART]
    },
    getGoodsNumPrice (state) {
      return state[types.UPDATE_GOODS_NUM_PRICE]
    },
    getGoodsCartStatus (state) {
      return state[types.POST_GOODS_CART]
    },
    getDelGoodsStatus (state) {
      return state[types.DEL_GOODS]
    },
    getGoodsTotalNum (state) {
      return state[types.GOODS_NUM]
    }

  }
}
export default distributor
